document.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('[data-js-product-add-to-cart]');
  const form = document.querySelector('[data-js-product-form]');
  const text = button?.querySelector('[data-js-product-add-to-cart-text]');
  const icon = button?.querySelector('[data-atc-icon]');

  if (!button || !form || !text || !icon) return;

  const defaultText = text.textContent.trim();
  let timer = null;

  form.addEventListener('add-to-cart', () => {
    clearTimeout(timer);

    button.classList.add('is-success');
    text.textContent = 'Im Warenkörbchen';
    icon.innerHTML = '<i class="fa-solid fa-paw" aria-hidden="true"></i>';

    timer = setTimeout(() => {
      button.classList.remove('is-success');
      text.textContent = defaultText;
      icon.innerHTML = '<i class="fa-solid fa-basket-shopping" aria-hidden="true"></i>';
    }, 4000);
  });
});